import { render } from "./index.vue?vue&type=template&id=b116f9e6&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=b116f9e6&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b116f9e6"],['__file',"src/views/mobile/account_center/index.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "b116f9e6"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('b116f9e6', __exports__)) {
    api.reload('b116f9e6', __exports__)
  }
  
  module.hot.accept("./index.vue?vue&type=template&id=b116f9e6&scoped=true", () => {
    api.rerender('b116f9e6', render)
  })

}


export default __exports__